<template>
  <div>
    <div>
      <label>FATURAMENTO(S) PENDENTE(S) ATÉ DATA</label>
      <div class="input-group">
        <input type="date" class="form-control" v-model="date" />
        <div class="input-group-pprend">
          <v-btn
            :loading="loading"
            :disabled="loading"
            class="v-warning noBorderRadius"
            @click="search"
          >
            <i class="fas fa-search mr-2"></i>
            BUSCAR FATURAMENTO(S) PENDENTE(S) PARA FECHAMENTO
          </v-btn>
        </div>
      </div>
    </div>
    <div
      v-if="
        data.hosting.data.length == 0 &&
        data.service.data.length == 0 &&
        data.stock_sale.data.length == 0
      "
      class="text-center mt-2 p-2 v-clean"
    >
      0 faturamento(s) pendente(s)!
    </div>
    <hosting
      :loading="loading"
      :resident_id="resident_id"
      :finance_client_id="finance_client_id"
      :data="data.hosting.data"
      :total_value="data.hosting.total_value"
      :start="start"
      :end="end"
      :finance_client="finance_client"
      :finance_configuration_payment_methods="
        finance_configuration_payment_methods
      "
      :finance_configuration_category="finance_configuration_category"
      :finance_configuration_profit_cost_center="
        finance_configuration_profit_cost_center
      "
      :finance_configuration_tag="finance_configuration_tag"
      :cost_types="cost_types"
      :cost_appropriations="cost_appropriations"
      :finance_configuration_category_id="finance_configuration_category_id"
      v-if="permission('read', 'resident_hosting')"
      @items="handleItems"
      @itemsChecked="handleItemsHostingChecked"
    />
    <service
      :loading="loading"
      :resident_id="resident_id"
      :finance_client_id="finance_client_id"
      :data="data.service.data"
      :total_value="data.service.total_value"
      :start="start"
      :end="end"
      :finance_client="finance_client"
      :finance_configuration_payment_methods="
        finance_configuration_payment_methods
      "
      :finance_configuration_category="finance_configuration_category"
      :finance_configuration_profit_cost_center="
        finance_configuration_profit_cost_center
      "
      :finance_configuration_tag="finance_configuration_tag"
      :cost_types="cost_types"
      :cost_appropriations="cost_appropriations"
      :finance_configuration_category_id="finance_configuration_category_id"
      v-if="permission('read', 'resident_service')"
      @items="handleItems"
      @itemsChecked="handleItemsServiceChecked"
    />
    <stock-sale
      :loading="loading"
      :resident_id="resident_id"
      :finance_client_id="finance_client_id"
      :data="data.stock_sale.data"
      :total_value="data.stock_sale.total_value"
      :start="start"
      :end="end"
      :finance_client="finance_client"
      :finance_configuration_payment_methods="
        finance_configuration_payment_methods
      "
      :finance_configuration_category="finance_configuration_category"
      :finance_configuration_profit_cost_center="
        finance_configuration_profit_cost_center
      "
      :finance_configuration_tag="finance_configuration_tag"
      :cost_types="cost_types"
      :cost_appropriations="cost_appropriations"
      :finance_configuration_category_id="finance_configuration_category_id"
      v-if="permission('read', 'resident_rest_home_sale_resident')"
      @items="handleItems"
      @itemsChecked="handleItemsStockSaleChecked"
    />
    <div
      v-if="
        data.hosting.data.length > 0 ||
        data.service.data.length > 0 ||
        data.stock_sale.data.length > 0
      "
      class="text-right mt-2 mb-2"
    >
      <v-btn
        @click="postPendingBilling"
        :loading="loading"
        :disabled="
          loading ||
          (itemsHostingChecked.length == 0 &&
            itemsServiceChecked.length == 0 &&
            itemsStockSaleChecked.length == 0)
        "
        class="v-success"
        >FINALIZAR FATURAMENTO(S) PENDENTE(S) SELECIONADO(S)</v-btn
      >
    </div>
    <ErrorsMessages :errors="errors" />
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages.vue";

import Hosting from "./closure/hosting.vue";
import Service from "./closure/service.vue";
import StockSale from "./closure/stock-sale.vue";

import api from "../../../../../services/api";

import {
  formatDate,
  professionalClassCouncilValue,
} from "../../../../../lib/format";

import moment from "moment";

import permission from "../../../../../lib/permission";

import toast from "../../../../../lib/ToastNotification";

export default {
  name: "Closure",

  components: {
    ErrorsMessages,
    Hosting,
    Service,
    StockSale,
  },

  props: {
    id: [String, Number],
    finance_launch_bills_to_pay_id: [String, Number],
    resident_id: [String, Number],
    finance_client_id: [String, Number],
    finance_client: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
  },

  data() {
    return {
      loading: false,

      date: moment().format("YYYY-MM-DD"),
      start: moment().subtract(30, "days").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),

      finance_configuration_category_id: null,

      data: {
        hosting: {
          data: [],
          total_value: 0,
        },
        service: {
          data: [],
          total_value: 0,
        },
        stock_sale: {
          data: [],
          total_value: 0,
        },
      },

      items: [],
      itemsHostingChecked: [],
      itemsServiceChecked: [],
      itemsStockSaleChecked: [],

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    formatDate,
    professionalClassCouncilValue,

    retrieve() {
      this.search();

      let { finance_configuration_category } = this;
      for (let category of finance_configuration_category) {
        if (category.default == 1) {
          this.finance_configuration_category_id = category.id;
        }
      }
    },

    async search() {
      try {
        this.loading = true;

        const { resident_id, start, end, date } = this;

        let params = {
          resident_id,
          start,
          end,
          date,
          status: 0,
        };

        const response = await api.get("/rest-home/family/releases", {
          params,
        });

        const { data } = response.data;

        let hosting = { data: [], total_value: 0 };
        let service = { data: [], total_value: 0 };
        let stock_sale = { data: [], total_value: 0 };

        if (permission("read", "resident_hosting")) {
          hosting = data.hosting;
        }

        if (permission("read", "resident_service")) {
          service = data.service;
        }

        if (permission("read", "resident_rest_home_sale_resident")) {
          stock_sale = data.stock_sale;
        }

        this.data = { hosting, service, stock_sale };

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleItems(items) {
      this.items.push(...items);
    },

    handleItemsHostingChecked(items) {
      this.itemsHostingChecked = items;
    },

    handleItemsServiceChecked(items) {
      this.itemsServiceChecked = items;
    },

    handleItemsStockSaleChecked(items) {
      this.itemsStockSaleChecked = items;
    },

    async postPendingBilling() {
      try {
        this.loading = true;

        const {
          id,
          finance_launch_bills_to_pay_id,
          resident_id,
          itemsHostingChecked,
          itemsServiceChecked,
          itemsStockSaleChecked,
        } = this;

        let items = [
          ...itemsHostingChecked,
          ...itemsServiceChecked,
          ...itemsStockSaleChecked,
        ];

        let params = {
          id,
          finance_launch_bills_to_pay_id,
          resident_id,
          items,
        };

        const response = await api.post(
          "/rest-home/financial/launch/pay/items-pending-billing",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("postPendingBilling");
          this.search();
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
